import React, { useEffect, useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import cn from '@/utils/cn';
import I18n from '@/modules/i18n';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import { useModalManager } from '@/components/common/Modal';
import useGradesTableStore from '../store/useGradesTableStore';
import FiltersPopup from './FiltersPopup';

const FilterButton = () => {
  const filters = useGradesTableStore(state => state.filters);
  const setFilter = useGradesTableStore(state => state.setFilter);
  const { close, isOpen, open } = useModalManager();
  const containerRef = useRef<HTMLDivElement>(null);
  const filterCount = Object.values(filters).reduce((sum, f) => sum + f.length, 0);
  const hasFilters = filterCount > 0;

  useOnClickOutside(containerRef, () => close());

  const initialFilters = new URLSearchParams(window.location.search);
  const gradingStatus = initialFilters.get('grading_status');

  useEffect(() => {
    if (!gradingStatus) return;

    setFilter({ gradingStatus: [gradingStatus] });
  }, [gradingStatus]);

  return (
    <div ref={containerRef} className="tw-relative">
      <button
        className={cn(
          'btn tw-mr-4',
          {
            'btn--outline-purple': !hasFilters,
            'btn--purple': hasFilters,
          },
        )}
        type="button"
        onClick={() => (isOpen ? close() : open())}
      >
        <div className="tw-flex tw-items-center">
          <Icon icon="Filter" size={14} />
          {hasFilters && (
            <span className={`tw-mx-1 tw-text-tci-purple tw-bg-white
                              tw-rounded-full tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center`}
            >
              {filterCount}
            </span>
          )}

          <Text size="xs">
            {I18n.t('apply_filters')}
          </Text>
        </div>
      </button>
      {isOpen && <FiltersPopup closeModal={close} />}
    </div>
  );
};

export default FilterButton;
